import { render, staticRenderFns } from "./InputDocument.vue?vue&type=template&id=f1f251f4"
import script from "./InputDocument.vue?vue&type=script&lang=js"
export * from "./InputDocument.vue?vue&type=script&lang=js"
import style0 from "./InputDocument.vue?vue&type=style&index=0&id=f1f251f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports